var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-filter"},_vm._l((_vm.suite),function(item){return _c('div',{key:item,staticClass:"market-filter-option",class:{ active: _vm.current === item },on:{"click":function($event){return _vm.change(item)}}},[_vm._v("\n    "+_vm._s(_vm.$t('filters.markets.' + _vm.titles[item]))+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e37d134","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/eventview/MarketFilter.vue
// module id = null
// module chunks = 